import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyPlanPageRedirectRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps-redirect',
	path: '/secure/PortfolioPlanView.jspa',
};
